const closers = new Map<string, () => void>();

const closingIds = new Set<string>();

export const registerToastCloser = (id: string, closer: () => void) => {
    closingIds.delete(id);

    closers.set(id, closer);

    return () => {
        if(closers.get(id) === closer) {
            closers.delete(id);
        }
    };
};

export const closeRegisteredToast = (id?: string): boolean => {
    const closer = id ? closers.get(id) : undefined;

    if(!id || !closer) {
        return false;
    }

    closers.delete(id);

    closingIds.add(id);

    closer();

    return true;
};

export const removeToastCloser = (id: string) => {
    closers.delete(id);

    closingIds.add(id);
};

export const isToastClosing = (id: string): boolean => closingIds.has(id);

export const forgetClosingToast = (id?: string) => {
    if(id) closingIds.delete(id);
};
